import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const ContentBlockSkeleton = () => {
  return (
    <>
      <SkeletonBlock $width="100%" $height="350px" />
      <SkeletonSpacer>
        <SkeletonBlock $width="25%" $height="34px" />
      </SkeletonSpacer>
      <SkeletonSpacer>
        <SkeletonBlock $width="35%" $height="45px" />
      </SkeletonSpacer>
      <SkeletonSpacer>
        <SkeletonBlock $width="25%" $height="300px" />
        <SkeletonBlock $width="25%" $height="300px" />
        <SkeletonBlock $width="25%" $height="300px" />
      </SkeletonSpacer>
    </>
  );
};

const SkeletonSpacer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  opacity: 0.7;
`;
